import React, { useState, useContext } from "react";
import { IndexContext } from '../../context'

const Search = ({ userZip }) => {
  const { baseUrl } = useContext(IndexContext);

  const [state, setState] = useState({
    query: "",
    zipCodeQuery: userZip || ""
  });

  const onSubmit = (isAdvanced = false) => {
    const query = new URLSearchParams({
      ...state,
      advanced: isAdvanced,
    })
      .toString()
      .replaceAll("&", ";");

    location = `${baseUrl}/organizations/find/${query};/`;
  }

  const onChange = (fieldName, e) => {
    setState({
      ...state,
      [fieldName]: e.target.value
    })
  }

  return (
    <section className="index-search">
      <div className="container-block index-search-inner">
        <h2 className="index-search-heading">
          Organization Name, Aircraft Name, Manufacturer or Model:
        </h2>
        <form
          name="searchForm"
          id="searchForm"
          method="get"
          className="index-search-form"
        >
          <div className="index-search-form-controls">
            <div className="index-search-form-input-wrap">
              <input
                type="text"
                className="index-search-form-input"
                name="query"
                placeholder="I want to fly!"
                value={state.query}
                onChange={(e) => onChange("query", e)}
              />
              <input
                type="text"
                className="index-search-form-input"
                name="zipCodeQuery"
                placeholder="Zip code"
                value={state.zipCodeQuery}
                onChange={(e) => onChange("zipCodeQuery", e)}
              />
            </div>
            <button className="index-search-btn" type="button" onClick={() => onSubmit(false)}>
              <svg width="15px" height="15px" className="vg-sprite index-search-btn-icon">
                <use href={baseUrl + "/public/images/shapes.svg?v=#search"}/>
              </svg>
              <span>Search</span>
            </button>
          </div>
          <button className="index-search-advanced-btn" type="button" onClick={() => onSubmit(true)}>
            <svg width="15px" height="15px" className="svg-sprite plus-symbol-icon">
              <use href={baseUrl + "/public/images/shapes.svg?v=3.1.482-t.722#plus-thin"}/>
            </svg>
            Advanced Search
          </button>
        </form>
      </div>
    </section>
  );
};

export default Search;
